
const INITIAL_STATE = {
    concessions: [],

};

const ConcessionReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'GET_CONCESSION':
            return {
                ...state,
                concessions: action.payload
            };

        default:
            return state;
    }
};

export default ConcessionReducer;
